"use strict";
var collection = require("../internals/collection");
var collectionStrong = require("../internals/collection-strong");
collection("Map", function(init) {
  return function Map() {
    return init(this, arguments.length ? arguments[0] : void 0);
  };
}, collectionStrong);
